(() => {
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => {
    if (!root || root.dataset.zingPromoReady === 'true') return;
    root.dataset.zingPromoReady = 'true';

    const track = root.querySelector('[data-zing-promo-track]');
    const prev = root.querySelector('[data-zing-promo-prev]');
    const next = root.querySelector('[data-zing-promo-next]');
    if (!track) return;

    const step = () => {
      const item = track.querySelector('.zing-promo-strip__item');
      return item ? item.getBoundingClientRect().width : Math.max(240, track.clientWidth * .8);
    };

    const update = () => {
      if (!prev || !next) return;
      const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };

    if (prev) {
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reducedMotion ? 'auto' : 'smooth' }));
    }
    if (next) {
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reducedMotion ? 'auto' : 'smooth' }));
    }

    let frame = null;
    track.addEventListener('scroll', () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });

    update();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-zing-promo-strip]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
